import arbNovaLogo from 'assets/img/arbitrum-nova-logo.svg'
import baseLogo from 'assets/img/base-logo.svg'
import binanceSmartChainLogo from 'assets/img/binance-smart-chain.svg'
import bitcoinCashLogo from 'assets/img/bitcoin-cash.svg'
import dashLogo from 'assets/img/dash.svg'
import dogecoinLogo from 'assets/img/dogecoin.svg'
import litecoinLogo from 'assets/img/litecoin.svg'
import nearLogo from 'assets/img/near.svg'
import xprLogo from 'assets/img/proton-xpr.svg'
import rootstockLogo from 'assets/img/rootstock.svg'
import zrxLogo from 'assets/img/tokens/0x-zrx-logo.svg'
import aaveLogo from 'assets/img/tokens/aave-aave-logo.svg'
import ampLogo from 'assets/img/tokens/amp-amp-logo.svg'
import apeLogo from 'assets/img/tokens/apecoin-ape-logo.svg'
import arbLogo from 'assets/img/tokens/arbitrum-arb-logo.svg'
import avaxLogo from 'assets/img/tokens/avalanche-avax-logo.svg'
import bitcoinLogo from 'assets/img/tokens/bitcoin-btc-logo.svg'
import bitGoLogo from 'assets/img/tokens/bitgo-got-logo.svg'
import cantoLogo from 'assets/img/tokens/canto-logo.svg'
import cardanoAdaLogo from 'assets/img/tokens/cardano-ada-logo.svg'
import circleLogo from 'assets/img/tokens/circle-usdc-logo.svg'
import ethAvatar from 'assets/img/tokens/eth-avatar.svg'
import ensLogo from 'assets/img/tokens/ethereum-name-service-ens-logo.svg'
import flowLogo from 'assets/img/tokens/flow-flow-logo.svg'
import daiLogo from 'assets/img/tokens/multi-collateral-dai-dai-logo.svg'
import optimismLogo from 'assets/img/tokens/optimism-avatar.svg'
import polygonLogo from 'assets/img/tokens/polygon-matic-logo.svg'
import solanaAvatar from 'assets/img/tokens/solana-avatar.svg'
import sushiLogo from 'assets/img/tokens/sushiswap-sushi-logo.svg'
import lunaLogo from 'assets/img/tokens/terra-luna-luna-logo.svg'
import tetherAvatar from 'assets/img/tokens/tether-avatar.svg'
import runeLogo from 'assets/img/tokens/thorchain-rune-logo.svg'
import tronTrxLogo from 'assets/img/tokens/tron-trx-logo.svg'
import uniswapLogo from 'assets/img/tokens/uniswap-uni-logo.svg'
import wrappedBitcoinLogo from 'assets/img/tokens/wrapped-bitcoin-wbtc-logo.svg'
import wethLogo from 'assets/img/tokens/wrapped-ether-weth-logo.svg'
import DataSource from 'constants/sources/DataSource'
import {
  ADA,
  AAVE,
  AMP,
  APE,
  ARB,
  AVAX,
  BCH,
  BNB,
  BTC,
  DAI,
  DASH,
  DOGE,
  ENS,
  ETH,
  FLOW,
  GOT,
  LTC,
  LUNA,
  MATIC,
  NEAR,
  OP,
  RBTC,
  RUNE,
  SOL,
  SUSHI,
  TRX,
  UNI,
  USDC,
  USDT,
  WAVAX,
  WBTC,
  WETH,
  XPR,
  ZRX,
} from 'constants/Tokens'

const AVATAR_MAP = {
  [ADA]: {
    addresses: [],
    logo: cardanoAdaLogo,
  },
  [AAVE]: {
    addresses: [
      '0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9',
      '0xd6df932a45c0f255f85145f286ea0b292b21c90b',
      '3vAs4D1WE6Na4tCgt4BApgFfENbm8WY7q4cSPD1yM4Cg',
    ],
    logo: aaveLogo,
  },
  [AMP]: {
    addresses: [
      '0xff20817765cb7f73d4bde2e66e067e58d11095c2',
      'D559HwgjYGDYsXpmFUKxhFTEwutvS9sya1kXiyCVogCV',
    ],
    logo: ampLogo,
  },
  [APE]: {
    addresses: [
      '0x4d224452801aced8b2f0aebe155379bb5d594381',
      '0xb7b31a6bc18e48888545ce79e83e06003be70930',
    ],
    logo: apeLogo,
  },
  [ARB]: {
    addresses: ['0x912ce59144191c1204e64559fe8253a0e49e6548'],
    logo: arbLogo,
  },
  [AVAX]: {
    addresses: [],
    logo: avaxLogo,
  },
  [BCH]: {
    addresses: [],
    logo: bitcoinCashLogo,
  },
  [BNB]: {
    addresses: [],
    logo: binanceSmartChainLogo,
  },
  [BTC]: {
    addresses: [],
    logo: bitcoinLogo,
  },
  [DAI]: {
    addresses: [
      '0x6b175474e89094c44da98b954eedeac495271d0f',
      '0x8f3cf7ad23cd3cadbd9735aff958023239c6a063',
      'EjmyN6qEC1Tf1JxiG1ae7UTJhUxSwk1TCWNWqxWV4J6o',
    ],
    logo: daiLogo,
  },
  [DASH]: {
    addresses: [],
    logo: dashLogo,
  },
  [DOGE]: {
    addresses: [],
    logo: dogecoinLogo,
  },
  [ENS]: {
    addresses: ['0xC18360217D8F7Ab5e7c516566761Ea12Ce7F9D72'],
    logo: ensLogo,
  },
  [ETH]: {
    addresses: [],
    logo: ethAvatar,
  },
  [FLOW]: {
    addresses: ['0x5c147e74D63B1D31AA3Fd78Eb229B65161983B2b'],
    logo: flowLogo,
  },
  [GOT]: {
    addresses: ['0xe14ac14133b8dedb7a20b51e6b002511c4b5a4c4'],
    logo: bitGoLogo,
  },
  [LTC]: {
    addresses: [],
    logo: litecoinLogo,
  },
  [LUNA]: {
    addresses: [],
    logo: lunaLogo,
  },
  [MATIC]: {
    addresses: [
      '0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0',
      '0x0000000000000000000000000000000000001010',
      'C7NNPWuZCNjZBfW5p6JvGsR8pUdsRpEdP1ZAhnoDwj7h',
    ],
    logo: polygonLogo,
  },
  [NEAR]: {
    addresses: [],
    logo: nearLogo,
  },
  [OP]: {
    addresses: ['0x4200000000000000000000000000000000000042'],
    logo: optimismLogo,
  },
  [RBTC]: {
    addresses: [],
    logo: rootstockLogo,
  },
  [RUNE]: {
    addresses: ['0x3155ba85d5f96b2d030a4966af206230e46849cb'],
    logo: runeLogo,
  },
  [SOL]: {
    addresses: [
      'So11111111111111111111111111111111111111111',
      'So11111111111111111111111111111111111111112',
    ],
    logo: solanaAvatar,
  },
  [SUSHI]: {
    addresses: [
      '0x6b3595068778dd592e39a122f4f5a5cf09c90fe2',
      '0x0b3f868e0be5597d5db7feb59e1cadbb0fdda50a',
      'ChVzxWRmrTeSgwd3Ui3UumcN8KX7VK3WaD4KGeSKpypj',
    ],
    logo: sushiLogo,
  },
  [TRX]: {
    addresses: [],
    logo: tronTrxLogo,
  },
  [UNI]: {
    addresses: [
      '0x1f9840a85d5af5bf1d1762f925bdaddc4201f984',
      '0xb33eaad8d922b1083446dc23f610c2567fb5180f',
      '8FU95xFJhUUkyyCLU13HSzDLs7oC4QZdXQHL6SCeab36',
    ],
    logo: uniswapLogo,
  },
  [USDC]: {
    addresses: [
      '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
      '0x2791bca1f2de4661ed88a30c99a7a9449aa84174',
      'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
    ],
    logo: circleLogo,
  },
  [USDT]: {
    addresses: [
      '0xdac17f958d2ee523a2206206994597c13d831ec7',
      '0xc2132d05d31c914a87c6611c10748aeb04b58e8f',
      'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
    ],
    logo: tetherAvatar,
  },
  [WAVAX]: {
    addresses: ['0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7'],
    logo: avaxLogo,
  },
  [WBTC]: {
    addresses: [
      '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599',
      '0x1bfd67037b42cf73acf2047067bd4f2c47d9bfd6',
      '3NZ9JMVBmGAqocybic2c7LQCJScmgsAZ6vQqTDzcqmJh',
    ],
    logo: wrappedBitcoinLogo,
  },
  [WETH]: {
    addresses: [
      '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
      '0x7ceb23fd6bc0add59e62ac25578270cff1b9f619',
      '7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs',
    ],
    logo: wethLogo,
  },
  [XPR]: {
    addresses: [],
    logo: xprLogo,
  },
  [ZRX]: {
    addresses: [
      '0xe41d2489571d322189246dafa5ebde1f4699f498',
      'GJa1VeEYLTRoHbaeqcxfzHmjGCGtZGF3CUqxv9znZZAY',
    ],
    logo: zrxLogo,
  },
  [DataSource.Canto]: {
    addresses: [],
    logo: cantoLogo,
  },
  // Special case for Arbitrum Nova - The native token is ETH but we need to
  // show the arb nova logo in the wallet selector on the transactions page
  [DataSource.ArbitrumNova]: {
    addresses: [],
    logo: arbNovaLogo,
  },
  // Native token for BASE is also ETH
  [DataSource.Base]: {
    addresses: [],
    logo: baseLogo,
  },
} as const

export type TokenCode = keyof typeof AVATAR_MAP

export const getTokenLogo = (token: string) => {
  if (token in AVATAR_MAP) {
    const { logo } = AVATAR_MAP[token as TokenCode]

    return logo
  }

  return undefined
}

export default AVATAR_MAP
